import { ContactsDrawerParams } from '@/features/drawer/components/ContactsDrawer/enums/ContactsDrawerParams';
import TypographyService from '@/services/TypographyService/TypographyService';

export const getContactListFilterParams = () => {
  const params = new URLSearchParams(location.search);
  const prefix = 'contacts-';
  const contactHolderKey = prefix + ContactsDrawerParams.ContactHolder;
  const contactHolderIdKey = prefix + ContactsDrawerParams.ContactHolderId;
  const contactHolder = params.get(contactHolderKey);
  const contactHolderId = params.get(contactHolderIdKey);

  if (params.has(contactHolderKey) && params.has(contactHolderIdKey)) {
    return [
      {
        propertyName: TypographyService.capitalize(contactHolder ?? '') + 'Id',
        values: [Number(contactHolderId)],
      },
    ];
  }

  return Object.entries(
    [...params.entries()]
      .filter(([key]) => key.startsWith(prefix))
      .reduce((acc, [key, value]) => {
        const strippedKey = key.replace(prefix, '');
        if (!strippedKey) {
          return acc;
        }
        const existed = acc[strippedKey] || [];
        return {
          ...acc,
          [strippedKey]: [...existed, value],
        };
      }, {}),
  ).map(([key, values]) => ({
    propertyName: key,
    values,
  }));
};
